import { collection, getDocs, query, where } from '@firebase/firestore'
import { firebaseDb } from '@/firebase/init'

export const getParent = async () => {
  const docRef = await collection(firebaseDb, 'users')
  const q = query(docRef, where('role', '==', 'parent'))
  const querySnapshot = await getDocs(q)
  const data = []
  querySnapshot.forEach((snapshot) => {
    data.push({
      id: snapshot.id,
      photo: snapshot?.data()?.photoURL,
      label: snapshot?.data()?.name,
      value: snapshot?.data()?.name,
      name: snapshot?.data()?.name,
      username: snapshot?.data()?.username,
      email: snapshot?.data()?.email,
    })
  })

  return data
}
export const getConnectionRequest = async (parentId) => {
  const docRef = await collection(firebaseDb, 'connections')
  const q = query(docRef, where('parentId', '==', parentId))
  const querySnapshot = await getDocs(q)
  const data = []
  querySnapshot.forEach((snapshot) => {
    data.push({
      ...snapshot.data(),
      id: snapshot.id,
    })
  })
  return data
}
